import { render, staticRenderFns } from "./ExtFormDetail.vue?vue&type=template&id=11bd18c6&scoped=true&"
import script from "./ExtFormDetail.vue?vue&type=script&lang=js&"
export * from "./ExtFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExtFormDetail.vue?vue&type=style&index=0&id=11bd18c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bd18c6",
  null
  
)

export default component.exports